import { Typography } from '@mui/material'
import Grid, { GridSize } from '@mui/material/Grid'
import { useTheme } from '@mui/material/styles'
import React from 'react'
// import Grid, { GridSize, RegularBreakpoints } from '@mui/material/Grid'

interface MultipleGridSize {
  xs?: GridSize
  sm?: GridSize
  md?: GridSize
  lg?: GridSize
  xl?: GridSize
}
interface Input {
  id: string
  field: JSX.Element
  size: boolean | GridSize | MultipleGridSize
}
interface Content {
  id?: string
  name?: string
  icon?: JSX.Element
  inputs: Input[]
  hasDivider?: boolean
  group?: boolean
}
interface Props {
  content: Content[]
}

const FormGrid: React.FC<Props> = ({ content }) => {
  const theme = useTheme()
  return (
    <Grid
      container
      style={{
        // margin: theme.spacing(0, -3),
        width: `calc(100% + ${theme.spacing(6)}px)`,
      }}>
      {content.map((section: Content, idx: number) => (
        <Grid
          container
          sx={[
            {
              ...(section.hasDivider
                ? {
                    '&:not(:last-child)': {
                      marginBottom: 12,
                    },
                  }
                : ''),
            },
          ]}
          key={`${section.id}-${idx.toString()}`}
          size={12}>
          {section.name && (
            <Grid
              style={{
                padding: theme.spacing(0, 3),
                position: 'relative',
                ...(idx > 0 && {
                  marginTop: theme.spacing(3),
                }),
              }}
              size={12}>
              <Typography
                variant="overline"
                style={{
                  width: '100%',
                  display: 'inline-block',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}>
                {section.name}
              </Typography>
            </Grid>
          )}
          {section.inputs && (
            <Grid
              container
              key={`${section.id}-inputs`}
              sx={(theme) => ({
                [theme.breakpoints.down('sm')]: {
                  display: 'block',
                },
                ...(section.group && {
                  margin: '0px 12px',
                  padding: '16px 16px 0px 16px',
                  borderRadius: 8,
                  backgroundColor: '#F9F9F9',
                }),
              })}
              size={12}>
              {section.inputs.map(
                (input: Input) =>
                  Object.keys(input).length > 0 && (
                    <Grid
                      sx={[
                        {
                          padding: theme.spacing(1, 3),
                        },
                      ]}
                      size={input.size}
                      key={`${section.id}-${input.id}`}
                      {...(typeof input.size === 'object' && {
                        size: input.size,
                      })}>
                      {input.field}
                    </Grid>
                  ),
              )}
            </Grid>
          )}
        </Grid>
      ))}
    </Grid>
  )
}
export default FormGrid
